export const DEV_CIAN_URL = 'https://www.master.dev3.cian.ru';

export const CONTACT_LINK = 'https://www.cian.ru/contacts/';

export const TELEGRAM_HOSTS_LINK = 'https://t.me/cian_posutochno/128038/128579';

export const FIRST_GIFT_DOOR_LINK =
  'https://static.cdn-cian.ru/media/marketing/kak_podgotovitsya_k_novogodnemu_sezonu.pdf';

export const SECOND_GIFT_DOOR_LINK = 'https://static.cdn-cian.ru/media/novogodny_cheklist_for_hosts.pdf';

export const THIRD_GIFT_DOOR_LINK = 'https://music.yandex.ru/playlists/a59c77bc-c8dd-f9fb-b5c4-8e6a6319d410';

export const FOURTH_GIFT_DOOR_LINK = 'https://disk.yandex.ru/d/Hxa1xmvp7vqzhw';

export const SIXTH_GIFT_DOOR_LINK = 'https://vkvideo.ru/video-210379388_456239710?list=ln-iBzHMxQUW03c1QBnrH';

export const SEVENTH_DOOR_TELEGRAM_CHANNEL_LINK = 'https://l.cian.site/w65u';

export const SEVENTH_GIFT_DOOR_LINK = 'https://t.me/addstickers/cian_posutochno_stikers';

export const EIGHTH_DOOR_GIFT = 'https://l.cian.site/w65u';
